module.exports = __webpack_public_path__ + "static/media/eprezto-logo-bw.491172e7.svg";